var _path, _circle, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconFollowEntrega(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 38,
    viewBox: "0 0 46 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.9951 8.06822V8.00349C36.9774 7.95849 36.9557 7.9152 36.9304 7.87404L36.8818 7.80931L36.7847 7.70413L36.7281 7.65558L36.6229 7.60704H36.5825L19.009 0.422294C18.8144 0.34361 18.5967 0.34361 18.4021 0.422294L0.869103 7.48567H0.82865L0.723468 7.53422L0.666832 7.58277L0.56974 7.68795L0.521193 7.75267C0.495808 7.79384 0.474166 7.83712 0.456467 7.88213V7.94686C0.447971 8.01401 0.447971 8.08197 0.456467 8.14913V14.6219C0.456806 18.4746 0.359317 21.5835 0.359375 25.1158V28.4978C0.360993 28.8245 0.558918 29.1181 0.861013 29.2422L18.4021 36.524C18.4898 36.5588 18.583 36.5779 18.6772 36.5806C18.7715 36.5779 18.8646 36.5588 18.9523 36.524L36.4935 29.2422C36.7955 29.1181 36.9935 28.8245 36.9951 28.4978V8.27049C37.0036 8.20334 37.0036 8.13538 36.9951 8.06822ZM18.9758 2.33907L24.5293 4.72667L9.9479 10.8523L4.12743 8.52054L18.9758 2.33907ZM17.5938 34.2998L2.25188 27.6814V25.1077C2.25188 19.1123 2.25188 16.9201 2.25188 14.7271V9.72609L8.15903 12.2828L17.5938 16.3283V34.2998ZM18.7096 14.4123L12.3178 11.7342L26.9153 5.58431L33.5418 8.52863L24.438 12.2998L18.7096 14.4123ZM19.7849 34.2998V16.3283L24.0658 14.435L35.1188 9.70991L35.1592 27.6814L19.7849 34.2998Z",
    fill: "#D59B00"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 28,
    r: 9,
    fill: "white",
    stroke: "#D49B00",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.7071 27.2929C31.3166 27.6834 31.3166 28.3166 31.7071 28.7071L34.5355 31.5355C34.6371 31.6371 34.7551 31.7123 34.881 31.761C35.2392 31.9002 35.6615 31.8251 35.9507 31.5359L40.9005 26.5862C41.291 26.1956 41.291 25.5625 40.9005 25.172C40.5099 24.7814 39.8768 24.7814 39.4863 25.172L35.2433 29.4149L33.1213 27.2929C32.7308 26.9024 32.0976 26.9024 31.7071 27.2929Z",
    fill: "#DDAF33"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFollowEntrega);
export default __webpack_public_path__ + "static/media/icon-follow-entrega.e01c8d2ea426ff10807aa91c783e133f.svg";
export { ForwardRef as ReactComponent };